<template>
  <div class="install">
    <h4 v-if="steps[step]">
      {{ partner.name }} -
      {{ step | setText(steps[step].title) }}
    </h4>

    <template v-for="(value, stepKey) in steps">
      <template v-if="step == stepKey">
        <component
          :createTransaction="createTransaction"
          :updateOrder="updateOrder"
          :transaction="transaction"
          :order="order"
          :partner="partner"
          :partner_id="partner_id"
          :is="stepKey"
          @setStep="setStep"
          :key="stepKey"
          v-model="body"
        />
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "tbc",
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  watch: {},
  components: {
    add_user: () => import("./add_user"),
    add_card: () => import("./add_card"),
    purchases: () => import("./purchases"),
    processing: () => import("./processing"),
    done: () => import("./done"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed &&
        this.transaction.status > -1
      );
    },
  },
  data() {
    return {
      body: null,
      step: "add_user",
      steps: {
        add_user: {
          title: "Данные покупателя",
        },
        add_card: {
          title: "Добавить карту",
        },
        purchases: {
          title: "Товары в заказе",
        },
        processing: {
          title: "Процесс формирования",
        },
        done: {
          title: "Завершено",
        },
      },
    };
  },
};
</script>

